<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Create Invoice'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form" novalidate>
    <tidy-wrapper>
      @if (!loaded) {
        <ion-skeleton-text animated="true" style="height: 400px; border-radius: 6px" />
      }

      @if (loaded) {
        <tidy-card>
          <tidy-row>
            <tidy-text [header]="'Vendor'" />
          </tidy-row>
          <tidy-select
            [label]="'Choose Vendor'"
            formControlName="vendor_id"
            [form]="form.controls.vendor_id"
            [items]="vendorItems"
            [icon]="'assets/svg/person-outline.svg'"
            [submitted]="submitted"
            [errorMessage]="'Please choose a vendor'" />
        </tidy-card>

        <tidy-row class="extra-top-padding">
          <tidy-text [header]="'Line Items'" />
        </tidy-row>

        <div formArrayName="items">
          @for (item of items.controls; track $index; let i = $index) {
            <tidy-card [formGroupName]="i">
              <tidy-row [alignLastItemRight]="true">
                <tidy-text
                  [body]="'Item ' + (i + 1)"
                  [translate]="false" />
                @if (items.length > 1) {
                  <tidy-text
                    [actionBody]="'Remove'"
                    (action)="removeItem(i)"
                    class="link" />
                }
              </tidy-row>
              <tidy-input
                [label]="'Description'"
                formControlName="description"
                [form]="item.controls.description"
                [icon]="'assets/svg/create-outline.svg'"
                [submitted]="submitted"
                [errorMessage]="'Please enter a description'" />
              <tidy-input
                [label]="'Amount ($)'"
                formControlName="amount"
                [form]="item.controls.amount"
                [icon]="'assets/svg/cash-outline.svg'"
                [type]="'number'"
                [submitted]="submitted"
                [errorMessage]="'Please enter a positive amount'" />
              <tidy-select
                [label]="'Property'"
                formControlName="address_id"
                [form]="item.controls.address_id"
                [items]="addressItems"
                [icon]="'assets/svg/home-outline.svg'"
                [submitted]="submitted"
                [errorMessage]="'Please choose a property'" />
            </tidy-card>
          }
        </div>

        <tidy-button
          [text]="'+ Add Line Item'"
          [action]="boundAddItem"
          class="secondary" />

        <tidy-card>
          <tidy-row>
            <tidy-checkbox
              [items]="[{ viewValue: 'Send invoice email to vendor', value: true }]"
              formControlName="send_email" />
          </tidy-row>
        </tidy-card>

        @if (errorMessage) {
          <tidy-error-message [text]="errorMessage" />
        }

        <tidy-button
          [text]="'Create Invoice'"
          [action]="boundSubmit"
          class="primary" />
      }
    </tidy-wrapper>
  </form>
</ng-template>

<app-scroll-wrapper [templateContent]="content" />
